<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoEditar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoEditar">
				<form (keypress)="ocultarMensagem()" (ngSubmit)="f.form.valid && atualizar()"
				 #f="ngForm" name="form" novalidate>
					<div class="formgroup" >
						<div class="flex justify-content-center" *ngIf="loading">
							<p-progressSpinner></p-progressSpinner>
						</div>
						<div *ngIf="messagemVisivel">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true">
							</p-messages>
						</div>
						<div class="p-fluid p-formgrid grid" *ngIf="agendamentoDespesa && !loading">
							
							<div class="field col-12 md:col-3">
								<label htmlFor="planoContaEmpresaId">Especificação</label>
								<input type="text" pInputText name="planoContaEmpresaId" ngModel
									#planoContaEmpresaId="ngModel" [ngModel]="agendamentoDespesa.planoContaEmpresa?.descricao"
									[readOnly]="true"/>
							</div>
	
							<div class="field col-12 md:col-3">
								<label htmlFor="identificacao">Identificação</label>
								<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
									placeholder="Insira a Identificação" name="identificacao" ngModel
									#identificacao="ngModel" [(ngModel)]="agendamentoDespesa.identificacao"/>
							</div>
							<div class="field col-12 md:col-2">
								<label htmlFor="dataVencimento">Vencimento</label>
								<p-calendar
									[readonlyInput]="true"
									[showIcon]="true"
									dateFormat="dd/mm/yy"
									[showButtonBar]="true"
									name="dataVencimento" ngModel
									#dataVencimento="ngModel" [(ngModel)]="agendamentoDespesa.dataVencimento">
								</p-calendar>
							</div>
							<div class="field col-12 md:col-2">
								<label htmlFor="competencia">Competência</label>
									<p-calendar 
									view="month" 
									dateFormat="mm/yy"
									[showIcon]="true"
									[readonlyInput]="true" 
									name="competencia" ngModel
									#competencia="ngModel" [(ngModel)]="agendamentoDespesa.competencia">
									</p-calendar>
							</div>
							<div class="field col-12 md:col-2">
								<label htmlFor="valorFluxo">Valor da Parcela</label>
								<p-inputNumber name="valorFluxo" ngModel #valorFluxo="ngModel" mode="currency"
									inputId="currency-brazil" currency="BRL" locale="pt-BR" [allowEmpty]="false"
									[(ngModel)]="agendamentoDespesa.valorFluxo">
								</p-inputNumber>
								<div *ngIf="valorFluxo.value <= 0" class="alerta">
									<small>O valor não pode ser zero</small>
								</div>
							</div>
							<div class="field col-12 md:col-3" *ngIf="agendamentoDespesa.status === 2">
								<label htmlFor="tipoPagamento">Forma de Pagamento</label>
								<p-dropdown [options]="tiposPagamento" optionLabel="descricao"
									name="tipoPagamento" ngModel [(ngModel)]="agendamentoDespesa.tipoPagamento"
									#tipoPagamento="ngModel" [filter]="true" [required]="true">
								</p-dropdown>
							</div>
							<div class="field col-12 md:col-2" *ngIf="agendamentoDespesa.status === 2">
								<label htmlFor="dataFluxo">Data do Pagamento</label>
								<p-calendar
									[readonlyInput]="true"
									[showIcon]="true"
									dateFormat="dd/mm/yy"
									[showButtonBar]="true"
									name="dataFluxo" ngModel
									#dataFluxo="ngModel" [required]="true"
									[(ngModel)]="agendamentoDespesa.dataFluxo">
								</p-calendar>
							</div>
	
	
						</div>
						<div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!loading">
							<div class="col-12 md:col-4">
								<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
									type="submit" pButton icon="pi pi-check" label="Atualizar"
									class="p-button-outlined p-button-success md:w-9rem" [disabled]="!f.valid || (agendamentoDespesa?.valorFluxo ?? 0)  <= 0">
								</button>
								<ng-template #exibirBotaoFalso>
									<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Atualizar"
										class="p-button-outlined p-button-success md:w-9rem" [disabled]="true">
									</button>
								</ng-template>
							</div>
							<div class="col-12 md:col-4 flex justify-content-end">
								<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
									class="p-button-outlined md:w-9rem" routerLink="/apps/agendamento-despesa"></button>
							</div>
						</div>
						</div>
				</form>
			</div>
		</div>
	</div>
	